function initImageBannerMask() {
  const els = document.querySelectorAll('.image-banner-mask');
  if (els.length === 0) {
    return;
  }
  els.forEach(el => {
    let elPos = el.getBoundingClientRect();
    if (elPos.top + document.documentElement.scrollTop > 200) {
      el.style.opacity = `0.4`;
      return;
    }
    window.addEventListener("scroll", (e) => {
      let scrolledPercentage = Math.floor(window.scrollY / window.innerHeight * 100);
      if (scrolledPercentage > 1 && scrolledPercentage <= 100) {
        el.style.opacity = `${scrolledPercentage / 100}`;
      } else if (scrolledPercentage > 100) {
        el.style.opacity = `1`;
      } else {
        el.style.opacity = `0`;
      }
    });
  });
}

window.addEventListener('DOMContentLoaded', function () {
  initImageBannerMask();
});